module.exports = __webpack_public_path__ + "img/card1.396683e6.jpg";